import baseService from "../services/BaseService";

export const deleteCreditCards = async (id) =>
  baseService.delete(`creditcard/${id}`);

export const addCreditCard = async (adminId, body) =>
  baseService.post(`creditcard/${adminId}`, body);
